/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationListRequest {
    getFixupPrototypeFunction() { return UserDelegationListRequest.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationListRequest>): UserDelegationListRequest {
        let obj = Object.assign(new UserDelegationListRequest(), model);
        UserDelegationListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationListRequest>): UserDelegationListRequest {
        if (!model) return null;
        return UserDelegationListRequest.newInstance(<UserDelegationListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationListRequest) {
        if (!obj) return;

        models.UserDelegationListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationListRequest): boolean {
        Object.setPrototypeOf(obj, UserDelegationListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.UserDelegationSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.UserDelegationSortCriteria>;

}
